import Button from "components/Button";
import Modal from "components/Modal";
import toastMessage from "helpers/handleToastMessage";
import React from "react";
import { deactivateChannel } from "services/manageFamilies";
import ArrowLeft from "icons/arrow-circle-left-green.svg";
import Confirm from "icons/confirm-circle-white.svg";

type Props = {
  channelId: string;
  groupId: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  active: boolean;
  setChannelId: React.Dispatch<React.SetStateAction<string>>;
  rechargeChannels: () => void;
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

const ChangeStatusModal: React.FC<Props> = ({
  channelId,
  groupId,
  setLoading,
  active,
  setChannelId,
  rechargeChannels,
  show,
  setShow,
}): JSX.Element => {
  const changeStatus = async () => {
    if (!channelId) {
      return;
    }
    try {
      setLoading(true);
      const { data } = await deactivateChannel(groupId, channelId, active);

      toastMessage({
        message: "Updated the status of the current!",
        type: "success",
      });

      if (data) {
        setChannelId("");
        rechargeChannels();
      }
    } catch (error: any) {
      toastMessage({
        message: "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setChannelId("");
      setLoading(false);
      setShow(false);
    }
  };

  return (
    <Modal
      show={show}
      children={
        <div className="w-full h-44 bg-bt-white p-6 rounded-md">
          <div className="flex flex-row items-center justify-center">
            <span className="font-nunito font-light text-xl text-bt-black">
              Do you really want to change the status of the current channel?
            </span>
          </div>
          <div className="flex flex-row justify-around mt-10 mb-10">
            <div className="flex flex-col">
              <Button
                label={"Back"}
                iconLeft={ArrowLeft}
                className="bg-bt-white text-bt-green border border-bt-green h-10 w-28 font-sora rounded-full"
                onClick={() => {
                  setChannelId("");
                  setShow(false);
                }}
              />
            </div>
            <div className="flex flex-col">
              <Button
                label={"Confirm"}
                iconLeft={Confirm}
                className="bg-bt-green text-bt-white h-10 w-28 font-sora rounded-full"
                onClick={() => changeStatus()}
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ChangeStatusModal;
